import React from 'react';
import { connect } from 'react-redux';
import pageSelector from 'selectors/pageSelector';
import TabPane from './TabPane';

class TabContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeTab: 0 };
        this.onTabSelect = this.onTabSelect.bind(this);
        this.inferSelectedBucket = this.inferSelectedBucket.bind(this);
    }

    componentWillMount() {
        this.inferSelectedBucket(this.props.buckets);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.buckets !== nextProps.buckets) {
            this.inferSelectedBucket(nextProps.buckets);
        }
    }

    onTabSelect(tabIndex) {
        this.setState({ activeTab: tabIndex });
    }

    inferSelectedBucket(buckets = []) {
        const index = buckets.map((bucket) => bucket.__replaced).indexOf(true);
        if (index > 0) {
            this.setState({ activeTab: index });
        }
    }

    render() {
        const tabControls = [];
        const tabPanes = [];

        this.props.buckets.filter((bucket) => bucket.type !== 'hero').forEach((bucket, tabIndex) => {
            const active = (this.state.activeTab === tabIndex);
            const tabControl = (
                <li
                    key={`tabControl-${bucket.id}`}
                    onClick={() => this.onTabSelect(tabIndex)}
                    className={active ? 'active' : ''}
                >
                    <span>{bucket.name}</span>
                </li>
            );

            tabControls.push(tabControl);
            tabPanes.push(
                <TabPane
                    active={active}
                    name={bucket.name}
                    bucketId={bucket.id}
                    contents={bucket.contents}
                    key={`tabPane-${bucket.id}`}
                    tabIndex={tabIndex}
                />
            );
        });

        return (
            <div className="playback__content">
                <div className="tab-wrap">
                    <ul className="tabs alt" data-behavior="tabs_transform">
                        {tabControls}
                    </ul>
                </div>
                <div className="tab-content">
                    {tabPanes}
                </div>
            </div>
        );
    }
}

TabContainer.propTypes = {
    buckets: React.PropTypes.array
};

TabContainer.defaultProps = {
    buckets: []
};

const mapStateToProps = (state) => {
    const page = pageSelector(state) || {};
    return {
        buckets: page.buckets
    };
};

export default connect(mapStateToProps)(TabContainer);



// WEBPACK FOOTER //
// ./app/drawer/TabContainer.js